export enum SsoProviders {
  NUHS = 'nuhs',
}
